import { usePermissionsStore } from '#modules/auth/stores/permissions.store.js';

export const usePermissions = () => {
    const store = usePermissionsStore();

    const can = (permission) => store.hasPermission(permission);

    const canAny = (permissions) => permissions.some((p) => store.hasPermission(p));

    const canAll = (permissions) => permissions.every((p) => store.hasPermission(p));

    return {
        can,
        canAny,
        canAll,
    };
};
